import { useRun } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import { useState, useEffect } from "react";
import getPlasmidSequenceLineHeights from "../../providers/getPlasmidSequenceLineHeights";

/** @typedef SLHeightData
 * @property {string} filename
 * @property {string} relativePath
 * @property {number} lineCount
 * @property {number} estLineHeight
 * @property {number[]} lastLineHeights
 * @property {number} length
 */

/** @type {(setID: string, plasmidID: string, length: number) => SLHeightData | null} */
function useSequenceLineHeight(setID, plasmidID, length) {
	const [lineHeightData, setLineHeightData] = useState(null);
	const getSLLineHieght = useRun(getPlasmidSequenceLineHeights);

	useEffect(() => {
		if (length <= 0) return;
		getSLLineHieght(setID, plasmidID, length).then(setLineHeightData);
	}, [setID, plasmidID, length]);

	return lineHeightData;
}

export default useSequenceLineHeight;
